import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

type Product = {
    codProduto: number;
    descricao: string;
    qtdCompra: number;
    unCompra: string;
    qtdVenda: number;
    unVenda: string;
    preco: number;
    image: string;
    rating: number; 
    quantidade_item: number;
};

type CartContextType = {
    cartItems: Product[];
    addToCart: (product : Product) => void;
    removeFromCart: (codProduto: number) => void;
    decrementQuantity: (codProduto : number) => void;
    incrementQuantity: (codProduto : number) => void;
    clearCart: () => void;
};

const CartContext = createContext<CartContextType | undefined> (undefined);

export const CartProvider = ({ children } : { children : ReactNode}) => {
    const [cartItems, setCartItems] = useState<Product[]>(() => {
        const storedCart = localStorage.getItem("cartItems");
        return storedCart ? JSON.parse(storedCart) : [];
    });

    useEffect(() => {
        localStorage.setItem('cartItems', JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (product : Product) => {
        setCartItems(prev => {
            const item_existente = prev.find(item => item.codProduto === product.codProduto);
            if (item_existente) {
                return prev.map(item => item.codProduto === product.codProduto
                        ? { ...item, quantidade_item: item.quantidade_item + 1 }
                        : item
                );
            } else {
                const novoCarrinho = [...prev, { ...product, quantidade_item: 1 }];
                return novoCarrinho;
            }
        });
    };

    const incrementQuantity = (codProduto: number) => {
        setCartItems(prev =>
            prev.map(item => item.codProduto === codProduto
                    ? { ...item, quantidade_item: item.quantidade_item + 1 }
                    : item
            )
        );
    };
    
    const removeFromCart = (codProduto : number) => {
        setCartItems(prev => prev.filter(item => item.codProduto !== codProduto));
    };
    
    const decrementQuantity = (codProduto: number) => {
        setCartItems(prev =>
            prev.map(item =>
                item.codProduto === codProduto
                    ? { ...item, quantidade_item: Math.max(1, item.quantidade_item - 1) }
                    : item
            )
        );
    };

    const clearCart = () => {
        setCartItems([]); // Limpa o localstorage implicitamente
    };

    return(
        <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, decrementQuantity, incrementQuantity, clearCart}}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if(!context) throw new Error("useCart deve ser usado com CartProvider");

    return context;
};